import { LocalStorageUtils } from '../utils/LocalStorageUtils';

const USER_STATUS_ITEM_NAME = 'didomi_user_status';
const CURRENT_USER_STATUS_ITEM_NAME = 'didomi_current_user_status';

export const readConsentStatus = () =>
  LocalStorageUtils.read(CURRENT_USER_STATUS_ITEM_NAME);

export const saveConsentStatus = didomiUtils => {
  const status = didomiUtils.getUserStatusFromDidomi();
  const currentStatus = didomiUtils.getCurrentUserStatusFromDidomi();

  LocalStorageUtils.erase(USER_STATUS_ITEM_NAME);
  LocalStorageUtils.create(USER_STATUS_ITEM_NAME, status);

  LocalStorageUtils.erase(CURRENT_USER_STATUS_ITEM_NAME);
  LocalStorageUtils.create(CURRENT_USER_STATUS_ITEM_NAME, currentStatus);
};
